<template>
  <div class="app-forgot-password-channel">
    <div class="headline">
      <h4>
        <slot name="headline"></slot>
      </h4>
    </div>
    <div class="subline">
      <slot name="subline"></slot>
    </div>
    <div class="no-sms" v-if="noSmsChannel && !noChannel">
      <slot name="noSms"></slot>
    </div>
    <div class="no-email" v-if="noEmailChannel && !noChannel">
      <slot name="noEmail"></slot>
    </div>
    <div class="no-channel" v-if="noChannel">
      <slot name="noChannel"></slot>
    </div>
    <b-form id="input-channel-form" :novalidate="true">
      <div class="field-group">
        <LabeledRadioInput name="passwordresettype"
                           class="onlyRadioFormGroup"
                           :model.sync="inputChannel"
                           :invalid.sync="invalid.inputChannel"
                           first-radio-value="sms"
                           second-radio-value="email"
                           :is-first-disabled="noSmsChannel"
                           :is-second-disabled="noEmailChannel"
                           ref="nestedInputResetType"
        >
          <template slot="lblFirstOption">
            <slot name="smsCode"></slot>
          </template>
          <template slot="lblSecondOption">
            <slot name="email"></slot>
          </template>
          <template slot="txtInvalidRequiredBirthDateLiveFeedback">
            <slot name="invalidRequired"></slot>
          </template>
        </LabeledRadioInput>
      </div>
    </b-form>
    <MessageModal></MessageModal>
    <Stepper
      class="stepper"
      @next="save()"
      @prev="back()"
      css-class-next="filled next"
      css-class-prev="text prev"
    >
      <template slot="btnNext">
        <slot name="ctaNext"></slot>
      </template>
      <template slot="btnPrev">
        <slot name="ctaPrevious"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>
import { BForm } from 'bootstrap-vue'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import isValid from '@/mixins/validators/isValid'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import preFilledInput from '@/mixins/preFilledInput'
import validationFlow from '@/mixins/validators/validationFlow'
import MessageModal from '@/components/generic/MessageView/MessageList.vue'
import Stepper from '@/components/generic/Stepper.vue'
import LabeledRadioInput from '@/components/forms/LabeledRadioInput.vue'

export default {
  name: 'ForgotPasswordInputChannel',
  components: {
    LabeledRadioInput,
    Stepper,
    MessageModal,
    BForm
  },
  data () {
    return {
      loading: false,
      invalidMsisdn: false,
      viewError: false,
      invalid: {
        inputChannel: false
      }
    }
  },
  mounted () {
    this.startLoader()
    // reset error message from previous transactions
    this.resetErrorMessages()
    this.stopLoader()
  },
  methods: {
    ...mapActions('forgotPassword', [
      'performResetChannel'
    ]),
    ...mapMutations('forgotPassword', [
      'setView'
    ]),
    resetErrorMessages () {
      this.$store.commit('clearMessages', {}, { root: true })
    },
    save () {
      this.forceValidationOnNestedInputs()
      if (!this.inputChannel) {
        this.viewError = true
      }
      if (this.inputChannel) {
        this.loading = true
        this.performResetChannel({
          msisdn: this.msisdn,
          channel: this.inputChannel,
          isRegistration: this.isRegistration
        }).then(() => {
          this.loading = false
        }).catch((e) => {
          this.loading = false
        })
      } else {
        // ensure live feedback for validation errors
        this.vFlowGetFirstErrorElementName().then(function (result) {
          result = result !== '' ? result : 'passwordresettype'
          const data = {
            type: 'validation',
            message: 'required field missing',
            location: result + ' - unknown'
          }
          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('error', data)
          }
        })
      }
    },
    forceValidationOnNestedInputs () {
      Object.entries(this.$refs).forEach(([key, comp]) => {
        if (/^nestedInput/.test(key) && comp !== undefined) {
          comp.vflowForceFeedback()
        }
      })
    },
    back () {
      this.setView('input')
    }
  },
  computed: {
    ...mapGetters('forgotPassword', [
      'msisdn',
      'channel',
      'eligibleTokenChannels'
    ]),
    noSmsChannel () {
      return (!this.eligibleTokenChannels.includes('sms'))
    },
    noEmailChannel () {
      return (!this.eligibleTokenChannels.includes('email'))
    },
    noChannel () {
      return (!this.eligibleTokenChannels.includes('email') && !this.eligibleTokenChannels.includes('sms'))
    }
  },
  mixins: [
    validationMixin,
    isValid,
    preFilledInput('inputChannel', 'channel'),
    validationFlow

  ],
  props: {
    msisdnPlaceholder: {
      type: String,
      default: '+49'
    },
    isRegistration: {
      type: Boolean,
      default: false
    }
  },
  validations () {
    return {
      inputMsisdn: {
        required
      }
    }
  }
}
</script>
